import React, { useState } from 'react';
import { Box } from '@mui/material';
import { CustomButton, CustomRadioGroup } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';

const questionConfig = getQuestionConfig(ProfilerQuestionID.FMCG_BRAND_NUMBERS);


const BrandCount = ({
  questionId = ProfilerQuestionID.FMCG_BRAND_NUMBERS,
  title = questionConfig?.question,
  value,
  defaultValue = '',
  onChange,
  onSubmit,
  submitLabel = 'Submit',
  options = questionConfig?.options || [],
}) => {
  const isControlled = typeof value === 'string';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selectedValue = isControlled ? value : internalValue;

  const handleSelect = (nextValue) => {
    if (!isControlled) {
      setInternalValue(nextValue);
    }
    onChange?.(nextValue);
  };

  const handleSubmit = () => {
    onSubmit?.({
      question: [
        { id: questionId, value: selectedValue }
      ]
    });
  };

  return (
    <Box sx={cardStyles()}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
        <CardHeader title={title} />

        <CustomRadioGroup
          options={options}
          value={selectedValue}
          onChange={(_, val) => handleSelect(val)}
          name="brand-count"
          size='small'
        />

        <CustomButton
          size='small'
          label={submitLabel}
          onClick={handleSubmit}
          disabled={!selectedValue}
          sx={{ width: '100%', mt: 'auto', pt: 1 }}
        />
      </Box>
    </Box>
  );
};

export default BrandCount;
